import React from 'react';
import clsx from 'clsx';

import './OpClickable.scss';

interface ClickableProps {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  inline?: boolean;
  className?: string;
  [key: string]: any;
}

/**
 * OpClickable is a custom clickable button component designed for inline or block-level interactions.
 * It provides a semantic button element with consistent styling for clickable areas.
 * 
 * Use this component when you need a clickable element that doesn't have the full button styling
 * but requires proper accessibility (button semantics) and event handling.
 * 
 * @example
 * <OpClickable onClick={handleClick} inline>
 *   Click here
 * </OpClickable>
 * 
 */
export const OpClickable = ({
  onClick,
  inline,
  className = '',
  ...htmlButtonProps
}: ClickableProps) => {
  const classnames = clsx(
    'op-clickable',
    { 'op-clickable--inline': inline },
    { [className]: Boolean(className) },
  );
  return (
    <button
      type="button"
      className={classnames}
      onClick={onClick}
      {...htmlButtonProps}
    />
  );
};
